import { APP_CONFIG } from 'mangools-commons/dist/configs/app'
import queryString from 'query-string';
import { parse } from 'sources/parsers/UrlDataParser';

import ErrorCodes from 'mangools-commons/dist/constants/ErrorCodes';
import HumanService from 'mangools-commons/dist/services/HumanService';
import { TechnicalErrorReportService } from 'mangools-commons/dist/services/TechnicalErrorReportService';

// Constants
const ENDPOINT = '/url-metrics';

/**
 * Data source class handling retrieval of url metrics data from query.
 */
class UrlDataSource {
    /**
     * gets data from Link source
     *
     * @static
     * @param {string} url URL for which we want backlink metric data
     *
     */
    static getData({ accessToken }, { url }) {
        const requestQuery = queryString.stringify({ url });
        const requestURL = `${APP_CONFIG.API_HOST}${APP_CONFIG.API_PATH}${ENDPOINT}?${requestQuery}`;

        return fetch(requestURL, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-Access-Token': accessToken || '',
                'X-Human-Token': HumanService.gen(),
                'X-Mangools-Client': 'app',
            },
        })
            .then(response => {
                if (response.ok) {
                    return response
                        .json()
                        .then(data => ({
                            error: false,
                            payload: parse(data),
                        }))
                        .catch(ex => {
                            const payload = {
                                requestURL,
                                status: ErrorCodes.PARSE_ERROR,
                                text: ex.toString(),
                            };

                            TechnicalErrorReportService.report({ ...payload, method: 'GET' });

                            return { error: true, payload };
                        });
                } else {
                    return response.json().then(e => {
                        const payload = {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                            retryAfter: e.error ? e.error.retry_after : null,
                        };

                        TechnicalErrorReportService.report({ ...payload, method: 'GET' });

                        return { error: true, payload };
                    });
                }
            })
            .catch(ex => {
                const payload = {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                };

                TechnicalErrorReportService.report({ ...payload, method: 'GET' });

                return { error: true, payload };
            });
    }
}

export default UrlDataSource;
